import { Directive, HostListener, NgModule, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Utils } from '../utils';
import { CommonModule } from '@angular/common';
import { DropdownAnchorDirective } from './dropdown-anchor.directive';
import { DropdownLinkDirective } from './dropdown-link.directive';
import { AppDropdownDirective } from './dropdown.directive';
import { ScrollToDirective } from './scroll-to.directive';
import { SidebarDirective, SidebarContainerDirective, SidebarContentDirective, SidebarTogglerDirective } from './sidebar.directive';
import { HighlightjsDirective } from './highlightjs.directive';
import { FullScreenWindowDirective } from './full-screen.directive';

/**
 * Works with the ngx-mask US phone input; the control holds the 10 national digits.
 * - Pasting "+15125550114", "+1 (512) 555-0114" or "15125550114" fills in "(512) 555-0114".
 * - Typing "+1" is accepted, and so is a "1" typed first (US area codes never start with 1).
 */
@Directive({
  selector: '[appPhone]'
})
export class PhoneInputDirective {
  constructor(@Optional() @Self() private ngControl: NgControl) { }

  @HostListener('beforeinput', ['$event'])
  onBeforeInput(event: InputEvent): void {
    const control = this.ngControl?.control;
    if (control && !control.value && event.inputType === 'insertText' && (event.data === '1' || event.data === '+')) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const control = this.ngControl?.control;
    if (!control) { return; }
    event.preventDefault();
    control.setValue(Utils.parsePhone(event.clipboardData?.getData('text') ?? '').national.substring(0, 10));
    control.markAsDirty();
  }
}

const directives = [
  PhoneInputDirective,
  DropdownAnchorDirective,
  DropdownLinkDirective,
  AppDropdownDirective,
  ScrollToDirective,
  SidebarDirective,
  SidebarContainerDirective,
  SidebarContentDirective,
  SidebarTogglerDirective,
  HighlightjsDirective,
  FullScreenWindowDirective
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: directives,
  exports: directives
})
export class SharedDirectivesModule { }
